//
import ProductModel from '@/models/Warehouse/WhProduct'


export default async ({ name, wh_family_id, wh_subfamily_id }) => {
    //
    try {
        //
        const params   = [ 'product_name=' + name, 'family_id=' + wh_family_id, 'subfamily_id=' + wh_subfamily_id ]
            , route    = 'suggest_internal_code?'.concat( params.join( '&' ) )
            , response = await ProductModel.find( route )
        //
        return response
    } catch (error) {
        //
        return error.response.data
    }
}

//
